import {
    Tooltip as MuiToolTip,
    tooltipClasses,
    TooltipProps,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const ColorTooltip = styled(
    ({
        className,
        classes,
        maxWidth,
        ...props
    }: TooltipProps & { maxWidth?: string }) => (
        <MuiToolTip
            {...props}
            classes={{ popper: className, tooltip: classes?.tooltip }}
        />
    ),
)(({ theme, maxWidth }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#3C4049",
        boxShadow:
            "0px 0px 1px rgba(124, 128, 158, 0.25), 0px 8px 16px rgba(124, 128, 158, 0.15)",
        padding: "5px 8px",
        color: "#FFFFFF",
        maxWidth: maxWidth || "192px",
        borderRadius: "4px",
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#3C4049",
    },
}));

const Tooltip = (props) => {
    const {
        content = "",
        children,
        placement = "top",
        minLength = "1",
        maxWidth = "",
        ...otherProps
    } = props;

    // Ensure children is a single React element for MUI Tooltip
    const wrappedChildren = Array.isArray(children) ? (
        <span>{children}</span>
    ) : (
        children
    );

    // show the tooltip only if the content exceeds the max char limit and shows the ellipsis
    // if the typeof content is a react element then show the tooltip
    if (typeof content != "string" || content?.length > Number(minLength)) {
        return (
            <ColorTooltip
                arrow={true}
                title={
                    <Typography
                        variant="typography13"
                        component="div"
                        sx={{ color: "#FFFFFF" }}
                    >
                        {content}
                    </Typography>
                }
                placement={placement}
                maxWidth={maxWidth}
                {...otherProps}
            >
                {wrappedChildren}
            </ColorTooltip>
        );
    }
    return <>{content || children}</>;
};

export default Tooltip;
